import { RegisterPage } from "pages/register";

export default function RegisterRoute() {

  return <RegisterPage />;
}
